import type { Permission, Role } from '@hrms/shared';
import { post } from '@/lib/api-client';

export interface SessionUser {
  id: string;
  email: string;
  role: Role;
  employeeId: string | null;
  mustChangePassword: boolean;
  permissions: Permission[];
}

export interface AuthSession {
  accessToken: string;
  expiresIn: number;
  user: SessionUser;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ResetPasswordPayload {
  token: string;
  newPassword: string;
  confirmPassword: string;
}

export const authApi = {
  login: (payload: LoginPayload) => post<AuthSession>('/auth/login', payload),

  /** Uses the httpOnly cookie; there is no body to send. */
  refresh: () => post<AuthSession>('/auth/refresh'),

  logout: () => post<void>('/auth/logout'),

  forgotPassword: (email: string) => post<{ message: string }>('/auth/forgot-password', { email }),

  resetPassword: (payload: ResetPasswordPayload) =>
    post<{ message: string }>('/auth/reset-password', payload),

  changePassword: (payload: ChangePasswordPayload) =>
    post<AuthSession>('/auth/change-password', payload),
};
